// frontend/src/utils/UserProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const UserProtectedRoute = ({ children }) => {
  const { isAuthenticated, authLoading } = useContext(AuthContext);
  return authLoading ? <div>Loading...</div> : (isAuthenticated ? children : <Navigate to="/artist_login" />);
};

export default UserProtectedRoute;